export const TRUCKING_STATUSES = {
  pending: "Pending", in_progress: "In progress", done: "Done", cancelled: "Cancelled",
};

export function truckingOverview(jobs = []) {
  // Cancelled cards stay visible as history, but do not contribute to work totals.
  const included = jobs.filter(job => job.status !== "cancelled");
  const number = value => Number.isFinite(Number(value)) ? Number(value) : 0;
  return {
    jobs: included.length,
    inProgress: included.filter(job => job.status === "in_progress").length,
    completed: included.filter(job => job.status === "done").length,
    assignedTrucks: new Set(included.map(job => job.truck_id).filter(Boolean)).size,
    loads: included.reduce((sum, job) => sum + number((job.actual_loads ?? job.loads_done)), 0),
    tonnes: Math.round(included.reduce((sum, job) => sum + number((job.actual_tonnes ?? job.tonnes_done)), 0) * 100) / 100,
    cancelled: jobs.length - included.length,
    attention: included.filter(job => job.status !== "done").flatMap(job => {
      const reasons = [];
      if (!job.truck_id) reasons.push("No truck assigned");
      if (!job.driver_ids?.length) reasons.push("No driver assigned");
      if (job.priority === "urgent") reasons.push("Urgent priority");
      return reasons.length ? [{ job, reasons }] : [];
    }),
  };
}
